"use client";

import { useRouter, usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { MdHome, MdVolunteerActivism, MdHistory, MdAccountCircle, MdAdd } from "react-icons/md";

const GREEN = "var(--primary)";

function NavItem({ Icon, label, active, onClick, ariaLabel }) {
  return (
    <button onClick={onClick} aria-label={ariaLabel || label} className="flex flex-col items-center justify-center">
      <Icon className="text-xl" style={{ color: active ? GREEN : "#4B5563" }} />
      <span className="text-[10px] mt-0.5" style={{ color: active ? GREEN : "#4B5563" }}>
        {label}
      </span>
    </button>
  );
}

export default function CurvedBottomNav() {
  const t = useTranslations("BottomNav");
  const router = useRouter();
  const pathname = usePathname();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
      <div className="relative mx-auto max-w-md">
        <div className="relative h-[76px]">
          {/* Bar background */}
          <div className="absolute inset-0 rounded-t-3xl bg-white border-t border-gray-200 shadow-[0_-6px_16px_rgba(0,0,0,0.04)]" />

          {/* Curved notch */}
          <div className="pointer-events-none absolute -top-8 left-1/2 -translate-x-1/2">
            <svg width="140" height="70" viewBox="0 0 140 70" aria-hidden="true">
              <circle cx="70" cy="70" r="40" fill="#ffffff" />
            </svg>
          </div>

          {/* Hero FAB (primary action) */}
          <button
            onClick={() => router.push("/dreams/new")}
            aria-label={t("startCampaign")}
            className="absolute left-1/2 -translate-x-1/2 -top-7 w-14 h-14 rounded-full shadow-lg ring-2 ring-white active:scale-95 transition"
            style={{ backgroundColor: GREEN }}
          >
            <MdAdd className="text-white text-2xl mx-auto" />
          </button>

          {/* Tabs */}
          <div className="relative grid grid-cols-4 items-center h-full px-6">
            <NavItem Icon={MdHome} label={t("home")} active={pathname === "/app"} onClick={() => router.push("/app")} />
            <NavItem
              Icon={MdVolunteerActivism}
              label={t("campaigns")}
              active={pathname?.startsWith("/campaigns")}
              onClick={() => router.push("/campaigns")}
            />
            <NavItem
              Icon={MdHistory}
              label={t("history")}
              active={pathname?.startsWith("/history")}
              onClick={() => router.push("/history")}
            />
            <NavItem
              Icon={MdAccountCircle}
              label={t("account")}
              active={pathname === "/account"}
              onClick={() => router.push("/account")}
            />
          </div>
        </div>
      </div>
    </nav>
  );
}

